module.exports = __webpack_public_path__ + "assets/img/bin.16b96796.svg";